import React from "react";
import { money } from "utils/helpers";
import LogoView from "components/DataDisplay/LogoView";
import { getOfferTerms } from "../helpers";

const SelectedLenderSummary = ({
  offer,
  cartTotal,
  canToggle,
  expanded,
  onToggle,
}) => {
  const approved = parseFloat(offer.approved_amount) || 0;
  const { leaseType, frequency } = getOfferTerms(offer, cartTotal);
  const terms = [leaseType, frequency].filter(Boolean).join(" · ");

  return (
    <div className="lender-summary">
      <span className="lender-summary__logo">
        <LogoView provider={offer.specific_provider_name} />
      </span>
      <div className="lender-summary__info">
        {terms && <div className="lender-summary__terms">{terms}</div>}
        <div className="lender-summary__sub">
          Approved to ${money(approved)} · selected offer
        </div>
      </div>
      {canToggle && (
        <button
          type="button"
          className="lender-summary__toggle"
          onClick={onToggle}
        >
          {expanded ? "Close" : "View other offers"}
        </button>
      )}
    </div>
  );
};

export default SelectedLenderSummary;
